import { Star, Quote } from "lucide-react";
import Reveal from "./Reveal";
import { useLang } from "../i18n/i18n";

const PEOPLE = [
  { name: "Jean-François D.", place: "Longueuil" },
  { name: "Sylvie C.", place: "Ahuntsic" },
  { name: "Daniel R.", place: "Rosemont" },
];

export default function Testimonials() {
  const { t } = useLang();
  return (
    <section className="mx-auto max-w-7xl px-5 sm:px-8 py-24" data-testid="testimonials-section">
      <Reveal>
        <p className="text-xs tracking-[0.35em] uppercase text-gold">{t("testi.eyebrow")}</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-light text-cream max-w-2xl leading-tight">
          {t("testi.title1")} <em className="gold-text italic font-medium">{t("testi.title2")}</em>
        </h2>
        <p className="mt-4 max-w-xl text-sm sm:text-base leading-relaxed text-cream/60">{t("testi.sub")}</p>
      </Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {PEOPLE.map((p, i) => (
          <Reveal key={p.name} delay={0.06 * i} className="h-full">
            <div
              data-testid={`testi-card-${i + 1}`}
              className="group flex h-full flex-col rounded-2xl border border-gold/15 bg-panel/70 p-8 transition-all hover:border-gold/40 hover:bg-panel2 hover:-translate-y-1 duration-300"
            >
              <div className="flex items-center justify-between">
                <div className="flex gap-1 text-gold" aria-label="5/5">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star key={s} size={13} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <Quote size={18} className="text-gold/30" />
              </div>
              <p className="mt-5 flex-1 text-sm leading-relaxed text-cream/75">{t(`testi.${i + 1}.text`)}</p>
              <div className="mt-6 flex items-center gap-3 border-t border-gold/10 pt-5">
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full border border-gold/30 font-display text-sm text-gold">
                  {p.name[0]}
                </span>
                <div>
                  <p className="text-sm font-semibold text-cream">{p.name}</p>
                  <p className="text-xs text-mutedc">{p.place}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
